module.exports = __webpack_public_path__ + "img/not_found.c1c209a2.svg";